import { CONTACT_SALES_URL } from '../../constants';
import { ChevronRightIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';

interface Props {
    text: string;
};

/** Shown when the requested quantity is above what can be bought self-serve. */
function ContactSalesNotice({ text }: Props) {
    const openContactSales = () => {
        window.open(CONTACT_SALES_URL, '_blank');
    };

    return (
        <div className={styles.info}>
            <h6>{text}</h6>
            <div className={styles.info_link} onClick={openContactSales}>
                <span>Contact sales</span>
                <ChevronRightIcon />
            </div>
        </div>
    );
};

export default ContactSalesNotice;
